// extracted by mini-css-extract-plugin
export default {"timeRow":"EditExamScopeModal_timeRow__wI26f","timeInput":"EditExamScopeModal_timeInput__snfoB","ml":"EditExamScopeModal_ml__sD-Xp"};